module.exports = __webpack_public_path__ + "static/media/shs-logo-white.45b51afc.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/shs-logo-white.svg
// module id = 1327
// module chunks = 0